import { Button, message, Popconfirm, Row } from 'antd'
import { CargoApi } from '../../../../api/Purchase/Cargo'
import CreateFreightModal from '../../../../components/Purchasing/Cargo/CreateFreightModal'
import useModalData from '../../../../elements/Hooks/useModalData'
import { get } from 'lodash'
import React from 'react'
import { withRouter } from 'react-router-dom'

function CreateFreightModalCont({ selection, selectionRawData, history }) {
  const {
    visible,
    modalType,
    object: cargo,
    setObject: setCargo,
    submitting,
    checkForm,
    formRef,
    onShow,
    onCancel,
    setSubmitting,
    isNew,
  } = useModalData()

  async function submit() {
    let newObject = await checkForm()
    newObject.cargos = selection
    newObject.currentRoute = selectionRawData.map(d =>
      get(
        d.routes.filter(r => r.hasFreightBooking === false).sort(r => r.index),
        '[0]',
        {},
      ),
    )

    setSubmitting(true)
    try {
      const submitted = await CargoApi.createFreight(newObject)
      onCancel()
      if (submitted)
        history.push({
          pathname: `purchasing/Order/${submitted._key}/update`,
        })
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage || e)
    }
    setSubmitting(false)
  }

  return (
    <>
      <Popconfirm
        placement="left"
        title={`Please be aware that this will create a freight booking with a single cargo.  Do you wish to proceed ?`}
        onConfirm={onShow}
        okText="Yes"
        cancelText="No">
        <Button type={'primary'} size="small" icon={'plus'}>
          Create Freight Booking
        </Button>
      </Popconfirm>
      <CreateFreightModal
        {...{
          visible,
          modalType,
          cargo,
          setCargo,
          submitting,
          formRef,
          onShow,
          onCancel,
          setSubmitting,
          isNew,
          submit,
        }}
      />
    </>
  )
}

export default withRouter(CreateFreightModalCont)
